import { Field } from "formik"
import React from "react"
import moment from "moment"
import { Translate } from "utils/i18n-shim"
import { Box, FormControlLabel, Grid, Typography } from "@mui/material"
import { modelsTransformer } from "shared"
import {
  Autocomplete,
  Checkbox,
  PriceInput,
  RemoteAutocomplete,
  TextField
} from "shared/ui/berry-jass-formik"
import { DatePicker } from "shared/ui/berry-jass-formik"
import { usePolicy } from "entities/policy"
import { getPurchaseTypeLabel, purchaseTypes } from "../lib"
import { IntegrationParameters } from "./IntegrationParameters"
import { flexPurchaseProduct } from "entities/purchase-product"

export const PurchaseProductForm = ({ formik }) => {
  const availableDate = moment().add(1, "days")
  const canManagePurchasePrice = usePolicy("PurchaseProduct", {
    action_name: "manage_purchase_price"
  })?.data?.manage_purchase_price
  const flexProduct = flexPurchaseProduct(formik.values?.purchase_type?.id)

  return (
    <Grid container rowSpacing={3} columnSpacing={2}>
      <Grid item md={6}>
        <Field
          required
          fullWidth
          name="name"
          label={<Translate value="products.name.title" />}
          component={TextField}
        />
      </Grid>
      <Grid item md={6}>
        <Field
          required
          id="purchase-type-autocomplete"
          name="purchase_type"
          component={Autocomplete}
          label={<Translate value="product.product-type.title" />}
          options={purchaseTypes}
          getOptionLabel={getPurchaseTypeLabel}
        />
      </Grid>
      {!flexProduct && (
        <Grid item md={3}>
          <Field
            required
            fullWidth
            name="runtime_in_days"
            label={<Translate value="products.runtime-in-days.title" />}
            component={TextField}
            type="number"
          />
        </Grid>
      )}
      {!flexProduct && (
        <Grid item md={3}>
          <Field
            required
            fullWidth
            name="rrp"
            component={PriceInput}
            label={<Translate value="products.rrp.title" />}
          />
        </Grid>
      )}
      {flexProduct && (
        <Grid item md={3}>
          <Field
            required
            fullWidth
            name="purchase_price_discount_percent"
            component={PriceInput}
            label={
              <Translate value="products.purchase-price-discount-percent.title" />
            }
          />
        </Grid>
      )}
      {canManagePurchasePrice && !flexProduct && (
        <Grid item md={3}>
          <Field
            required
            fullWidth
            name="purchase_price"
            label={<Translate value="products.purchase_price.title" />}
            component={PriceInput}
          />
        </Grid>
      )}
      <Grid item md={canManagePurchasePrice ? 3 : 6}>
        <Field
          required={!flexProduct}
          fullWidth
          name="stock_quantity"
          label={<Translate value="products.stock.title" />}
          component={TextField}
          type="number"
        />
      </Grid>
      <Grid item md={6}>
        <Field
          minDate={availableDate}
          component={DatePicker}
          label={<Translate value="products.stock-date.title" />}
          name="stock_expires_at"
        />
      </Grid>
      <Grid item md={3}>
        <FormControlLabel
          label={
            <Typography variant="h6">
              <Translate value="product.free.title" />
            </Typography>
          }
          control={
            <Field name="is_free" component={Checkbox} color="primary" />
          }
        />
      </Grid>
      <Grid item md={12}>
        <Typography variant="subtitle1">
          <Translate value="purchase-products.schalttool.title" />
        </Typography>
        <Box mt={1.5}>
          <Field
            id="schalttool-autocomplete"
            name="schalttool"
            variant="search"
            component={RemoteAutocomplete}
            mapResponseToDataSource={modelsTransformer}
            label={<Translate value="purchase-products.schalttool.label" />}
            url="schalttools/choice.json"
          />
        </Box>
      </Grid>
      <Grid item md={12}>
        <IntegrationParameters formik={formik} />
      </Grid>
    </Grid>
  )
}
